import { getCurrentUserFromLocalStorage } from "./localStorageHelper";
import {
  getShoppingCartHubConnection,
  initializeShoppingCartConnection,
  getShoppingCart,
  onShoppingCartUpdated,
} from "../services/signalRService";

// Initialize shopping cart connection and subscribe to updates if user is logged in.
// Returns an unsubscribe function for the subscription.
export const initAndSubscribeShoppingCart = async (onUpdate) => {
  const currentUser = getCurrentUserFromLocalStorage();
  if (!currentUser) {
    return () => {};
  }

  const subscription = onShoppingCartUpdated.subscribe((data) => {
    if (data) {
      onUpdate(data);
    }
  });

  try {
    await initializeShoppingCartConnection(process.env.API_ENDPOINT);
    await getShoppingCart();
    getShoppingCartHubConnection().on("ShoppingCartUpdated", (data) => {
      onUpdate(data);
    });
  } catch (error) {}

  return () => subscription.unsubscribe();
};

// Map list of courses and add InCart flag based on shopping cart
export const markCoursesInCart = (courseList, cart) => {
  const productIdsInCart = new Set((cart?.shoppingCartItems || []).map((item) => item.entityPublicId));
  return (courseList || []).map((course) => ({
    ...course,
    InCart: productIdsInCart.has(course.publicId),
  }));
};

// Check if a single course is in cart
export const isInCart = (cart, coursePublicId) => {
  if (!coursePublicId) return false;
  const items = cart?.shoppingCartItems || [];
  return items.some((item) => item?.entityPublicId === coursePublicId);
};


